import { openBlock as o, createElementBlock as t, createElementVNode as n } from "vue";
const r = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
};
function l(c, e) {
  return o(), t("svg", r, e[0] || (e[0] = [
    n("path", {
      fill: "currentColor",
      d: "M3 16.142V8.245h2.323l2.322 2.903 2.323-2.903h2.322v7.897H9.968v-4.53l-2.323 2.904-2.322-2.903v4.529zm14.516 0-3.484-3.832h2.323V8.245h2.322v4.065H21z"
    }, null, -1)
  ]));
}
const s = { render: l };
export {
  s as default,
  l as render
};
